import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { LeafletControlDirective } from './leaflet-control.directive';

@Component({
  selector: 'lassi-zoom-control',
  imports: [MatButtonModule, MatIconModule, MatDivider],
  template: `
    <button aria-label="Zoom in" mat-icon-button (click)="zoomIn()">
      <mat-icon>add</mat-icon>
    </button>
    <mat-divider />
    <button aria-label="Zoom out" mat-icon-button (click)="zoomOut()">
      <mat-icon>remove</mat-icon>
    </button>
  `,
  styles: `
    @use '../../../../../node_modules/@angular/material/index' as mat;
    @use '../../../../../libs/webapp/webapp-component/src/styles/theme' as theme;

    :host {
      background-color: mat.get-theme-color(theme.$light-theme, on-primary);
      color: mat.get-theme-color(theme.$light-theme, on-surface-variant);
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 4px;
      border-radius: 16px;
      box-shadow: var(--mat-fab-container-elevation-shadow);

      mat-divider {
        align-self: stretch;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZoomControlComponent {
  private control = inject(LeafletControlDirective);

  zoomIn() {
    this.control.map.zoomIn();
  }

  zoomOut() {
    this.control.map.zoomOut();
  }
}
